//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import swal from "@sweetalert/with-react";
import Link from "@material-ui/core/Link";
import Tooltip from "@material-ui/core/Tooltip";

import { SocialMediaIconsReact } from "social-media-icons-react";
//......keep this import at last......
import { useStyles } from "../Styles";

export default function SocialMediaIcons() {
  const classes = useStyles();
  const gpayQRURL = "images/gpayQR.webp";
  const showDonationQR = () => {
    // swal({
    //   title: "Even slightest of your efforts will be appreciated :)",
    //   text: "scan this gpay QR code",
    //   icon: gpayQRURL,
    //   button: "I contributed",
    // });

    swal({
      buttons: {
        confirm: "I contributed :)",
      },
      content: (
        <div>
          <i>scan this gpay QR code</i>
          <br />
          <img src={gpayQRURL} alt="" />
          <br />
          <Typography variant="caption">vermakushal.28@okaxis</Typography>
          <br />
          <h3
            style={{
              fontFamily: "sans-serif",
              color: "darkred",
            }}
          >
            Even slightest of your efforts will be appreciated &#x1F609;
          </h3>
        </div>
      ),
    });
  };

  return (
    <React.Fragment>
      <div className={classes.socialMediaIcons}>
        <Tooltip
          title="Connect with me on twitter"
          interactive
          arrow
          placement="right"
        >
          <div className={classes.specificIcon}>
            {" "}
            <SocialMediaIconsReact
              borderWidth="1"
              borderColor="#00000000"
              className="abc"
              icon="twitter"
              iconColor="rgba(255,255,255,1)"
              backgroundColor="rgba(28,186,223,1)"
              iconSize="4"
              roundness="36%"
              url="https://twitter.com/Vermakushal28"
              size="30"
              Tooltip="false"
            />
          </div>
        </Tooltip>
        <Tooltip
          title="Connect with me on facebook"
          interactive
          arrow
          placement="right"
        >
          <div className={classes.specificIcon}>
            <SocialMediaIconsReact
              borderWidth="1"
              borderColor="#00000000"
              icon="facebook"
              iconColor="rgba(255,255,255,1)"
              backgroundColor="rgba(59,89,152,1)"
              iconSize="4"
              roundness="36%"
              url="https://www.facebook.com/kushal.verma.313"
              size="30"
            />
          </div>
        </Tooltip>
        <div>
          <Tooltip title="Personal account" interactive arrow placement="right">
            <span className={classes.specificIcon}>
              <SocialMediaIconsReact
                borderWidth="1"
                borderColor="#00000000"
                icon="instagram"
                iconColor="rgba(255,255,255,1)"
                backgroundColor="rgba(221,42,123,1)"
                iconSize="4"
                roundness="36%"
                url="https://www.instagram.com/kush2896/"
                size="30"
              />{" "}
            </span>
          </Tooltip>
          &nbsp;
          <Tooltip
            title="Photography account"
            interactive
            arrow
            placement="right"
          >
            <span className={classes.specificIcon}>
              <SocialMediaIconsReact
                borderWidth="1"
                borderColor="#00000000"
                icon="instagram"
                iconColor="rgba(255,255,255,1)"
                backgroundColor="rgba(251,15,15,1)"
                iconSize="4"
                roundness="36%"
                url="https://www.instagram.com/exp_click/"
                size="30"
              />
            </span>
          </Tooltip>
        </div>
        <Tooltip
          title="Connect with me on linkedIn"
          interactive
          arrow
          placement="right"
        >
          <div className={classes.specificIcon}>
            <SocialMediaIconsReact
              borderWidth="1"
              borderColor="#00000000"
              icon="linkedin"
              iconColor="rgba(255,255,255,1)"
              backgroundColor="rgba(14,118,168,1)"
              iconSize="4"
              roundness="36%"
              url="https://www.linkedin.com/in/kushalverma28/"
              size="30"
            />
          </div>
        </Tooltip>
        <Tooltip
          title="Connect with me on github"
          interactive
          arrow
          placement="right"
        >
          <div className={classes.specificIcon}>
            <SocialMediaIconsReact
              borderWidth="0"
              borderColor="#00000000"
              icon="github"
              iconColor="rgba(0,0,0,1)"
              backgroundColor="rgba(255,255,255,1)"
              iconSize="10"
              roundness="36%"
              url="https://github.com/vkushal28"
              size="30"
            />
          </div>
        </Tooltip>
        <div
          style={{
            width: "fit-content",
            // backgroundColor: "rgb(255, 165, 0)",
            // boxShadow: "rgba(190, 190, 190, 0.5) 0px 1px 2px 2px",
            color: "rgb(255, 255, 255)",
            borderRadius: "5px",
            padding: "4px 6px",
            display: "inline-flex",

            // boxSizing: "bord er-box",
          }}
        >
          <Typography>
            <Link href="#" onClick={showDonationQR} style={{ display: "flex" }}>
              <span>
                <img
                  src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
                  alt=""
                  style={{
                    height: "28px",
                  }}
                />
              </span>
              <span
                style={{
                  // color: "rgb(255, 255, 255)",
                  fontSize:"Inherit",
                  fontFamily: "Inherit",
                }}
              >
                Make a donation
              </span>
            </Link>
          </Typography>
        </div>
      </div>
    </React.Fragment>
  );
}
